import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import vailcode from "@utils/errcode";
import formatter from "@utils/formatter";
import cookie from "js-cookie";
export default {
  name: "popLuckyboxNewTip",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  watch: {
    "$parent.popTipShow": {
      handler(bool) {
        if (bool) {}
      }
    }
  },
  data() {
    return {};
  },
  methods: {}
};